/* ============================================================
   custom-nav.js — Outdoor Workout Supply
   BATCH 10.3 UPDATE: IIFEs 1-7 unchanged from 5.2
                      IIFE 8: Reviews page — rename title (names via CSS)
                      IIFE 9: About Us page — scope class for CSS Section 27
                      IIFE 10: Shipping Policy page — scope class for CSS Section 28
                      IIFE 11: FAQ page — scope class for CSS Section 29
                      IIFE 12: Refund Policy page — scope class for CSS Section 30
                      IIFE 13: Warranty page — scope class for CSS Section 31
                      IIFE 14: Payment Policy page — scope class for CSS Section 32
                      IIFE 15: Terms of Service page — scope class for CSS Section 33
                      IIFE 16: Privacy Policy page — scope class for CSS Section 34
                      IIFE 17: Disclaimer page — scope class for CSS Section 35
                      IIFE 18: Why Buy From Us — rename reviews title,
                               format reviewer names, hide review count
                      IIFE 19: Request a Quote — scope class + smart CTA
                               (page body is static HTML; shim adds only)
                      IIFE 20: Collection filters — auto-hide single-option
                               groups on desktop + move Manufacturer first
                      IIFE 21: Sort By cleanup — remove unwanted options,
                               inject mobile modal CSS (green tap, no active highlight)
                      10.4: IIFE 1 — positionSubmenu containing-block fix (About OWS dropdown drift on wide screens)
                      10.3: IIFE 21 — Sort By option removal + mobile CSS
                            + scroll preservation on filter/sort
                            + green highlight on active sort (mobile)
                            + robust mobile scroll restore (multi-attempt)
                      9.17: IIFE 20 — collection filter cleanup & reorder
                      9.16: CSS — Request a Quote page card styling (Section 37)
                      9.15: CSS — Why Buy From Us page refinement (Section 36)
                      9.14: CSS — Disclaimer page card styling (Section 35)
                      9.13: CSS — Privacy Policy page card styling (Section 34)
                      9.12: CSS — Terms of Service page card styling (Section 33)
                      9.11: CSS — Payment Policy page card styling (Section 32)
                      9.10: CSS — Warranty page card styling (Section 31)
                      9.9: CSS — Refund Policy page card styling (Section 30)
                     9.8: CSS — FAQ page card styling (Section 29)
                     9.7: CSS — Shipping Policy page card styling (Section 28)
                     9.6: CSS — About Us page card styling (Section 27)
                     9.5: CSS — Partners page 4-column grid (Section 26)
                     9.4: CSS — Installation page cleanup (Section 25)
                     9.3: CSS — Junip reviews cleanup (Section 24)
                     9.2: CSS-only — Contact form integration (Section 23)
                     9.1: CSS-only — Track Your Order card + notice callout
                     8.1: CSS-only — OWS info page card system (Section 22)
                     7.2: search icon hover darken + green button hover
                     Quotify "Back to Cart" handled via Quotify's Custom JS panel
                     (uses native close-quote-frame message — no parent-page JS needed)
   5.2: IIFE 7 — marks Product Description collapsible tabs with
        .collapsible-tab--description so CSS can target them
   4.6: IIFE 6 rewritten — capture-phase click + MutationObserver
        fallback, dual state check (aria-expanded + data-accordion-state)
   4.5: IIFE 6 click-delegation + aria-expanded (bubble phase only)
   4.2: accordion via Empire's data-accordion-* attrs (never fired)
   4.1: initial accordion attempt (CSS fought Empire animations)
   ============================================================ */


/* === CLICK-TO-OPEN MEGA MENU === */
(function() {
  var ourAction = false;
  var clickOpened = null; // tracks which <details> WE opened via click

  /* --- Positioning helpers (fix mega-menu layout on click-open) --- */
  /* v4: the left values below are measured relative to .site-navigation-wrapper,
     which is only correct while the submenu's containing block IS the wrapper
     (no positioned ancestor between submenu and wrapper). CSS Section 48 made
     the About OWS li position:relative (anchors its divider ::after), so that
     submenu now resolves left against the li instead — double-shifting it by
     the li's x (~250px at 1920, worse wider). After applying the inline styles,
     ask the browser for the real containing block (offsetParent) and, if it
     sits inside the wrapper, subtract its offset. Static-li items never enter
     the correction branch — their inline styles are byte-identical to v3. No
     navmenu-id class is referenced, so this survives menu renames and any
     future positioned li (basic or mega). */
  function positionSubmenu(details) {
    var submenu = details.querySelector(':scope > .navmenu-submenu');
    if (!submenu) return;
    var isMega = submenu.classList.contains('navmenu-meganav');
    var wrapper = document.querySelector('.site-navigation-wrapper');
    if (!wrapper) return;
    var wrapperRect = wrapper.getBoundingClientRect();

    if (isMega) {
      var nav = document.querySelector('.site-navigation');
      if (!nav) return;
      var navRect = nav.getBoundingClientRect();
      submenu.style.cssText =
        'display:block!important;position:absolute!important;top:100%!important;' +
        'left:' + (navRect.left - wrapperRect.left) + 'px!important;' +
        'width:' + navRect.width + 'px!important;' +
        'height:auto!important;overflow:visible!important;z-index:1102!important;';
    } else {
      var li = details.closest('.navmenu-item-parent');
      if (!li) return;
      var liRect = li.getBoundingClientRect();
      submenu.style.cssText =
        'display:block!important;position:absolute!important;top:100%!important;' +
        'left:' + (liRect.left - wrapperRect.left) + 'px!important;' +
        'height:auto!important;overflow:visible!important;z-index:1102!important;' +
        'background:#fff!important;padding:12px 16px!important;' +
        'box-shadow:0 4px 12px rgba(0,0,0,0.1)!important;min-width:200px!important;';
    }

    // v4 containing-block correction. Must run AFTER the styles above so the
    // submenu is rendered position:absolute and offsetParent is meaningful.
    var cb = submenu.offsetParent;
    if (cb && cb !== wrapper && wrapper.contains(cb)) {
      var shift = cb.getBoundingClientRect().left + cb.clientLeft - wrapperRect.left;
      if (shift) {
        submenu.style.setProperty('left',
          ((parseFloat(submenu.style.left) || 0) - shift) + 'px', 'important');
      }
    }
  }

  function clearSubmenuStyles(details) {
    var submenu = details.querySelector(':scope > .navmenu-submenu');
    if (submenu) submenu.style.cssText = '';
  }

  document.querySelectorAll('.navmenu-depth-1 > .navmenu-item-parent').forEach(function(li) {
    var details = li.querySelector(':scope > [data-navmenu-details]');
    if (!details) return;
    var summary = details.querySelector(':scope > summary');
    if (!summary) return;

    // Watch for Empire changing the open attribute (via hover).
    // If we didn't trigger it AND it's not a menu we click-opened, revert.
    var observer = new MutationObserver(function(mutations) {
      if (ourAction) return;
      mutations.forEach(function(m) {
        if (m.attributeName === 'open') {
          if (details.hasAttribute('open') && clickOpened !== details) {
            // Empire tried to hover-open a menu we didn't click — block it
            details.removeAttribute('open');
            clearSubmenuStyles(details);
          } else if (!details.hasAttribute('open') && clickOpened === details) {
            // Empire closed our click-opened menu (mouseleave) — let it close
            clickOpened = null;
            clearSubmenuStyles(details);
          }
        }
      });
    });
    observer.observe(details, { attributes: true });

    // Intercept clicks on the summary
    summary.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      ourAction = true;

      if (details.hasAttribute('open')) {
        // Closing
        details.removeAttribute('open');
        summary.setAttribute('aria-expanded', 'false');
        clearSubmenuStyles(details);
        clickOpened = null;
      } else {
        // Close other open menus
        document.querySelectorAll('.navmenu-depth-1 > .navmenu-item-parent > [data-navmenu-details][open]').forEach(function(d) {
          d.removeAttribute('open');
          var s = d.querySelector('summary');
          if (s) s.setAttribute('aria-expanded', 'false');
          clearSubmenuStyles(d);
        });
        // Open this one
        details.setAttribute('open', '');
        summary.setAttribute('aria-expanded', 'true');
        positionSubmenu(details);
        clickOpened = details;
      }

      setTimeout(function() { ourAction = false; }, 100);
    }, true);
  });

  // Close when clicking outside
  document.addEventListener('click', function(e) {
    if (e.target.closest('.navmenu-depth-1 > .navmenu-item-parent')) return;
    ourAction = true;
    clickOpened = null;
    document.querySelectorAll('.navmenu-depth-1 > .navmenu-item-parent > [data-navmenu-details][open]').forEach(function(d) {
      d.removeAttribute('open');
      var summary = d.querySelector('summary');
      if (summary) summary.setAttribute('aria-expanded', 'false');
      clearSubmenuStyles(d);
    });
    setTimeout(function() { ourAction = false; }, 100);
  });

  // Close on Escape
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      ourAction = true;
      clickOpened = null;
      document.querySelectorAll('.navmenu-depth-1 > .navmenu-item-parent > [data-navmenu-details][open]').forEach(function(d) {
        d.removeAttribute('open');
        var summary = d.querySelector('summary');
        if (summary) {
          summary.setAttribute('aria-expanded', 'false');
          summary.focus();
        }
        clearSubmenuStyles(d);
      });
      setTimeout(function() { ourAction = false; }, 100);
    }
  });

  // Recalculate positioning on window resize
  var resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
      document.querySelectorAll('.navmenu-depth-1 > .navmenu-item-parent > [data-navmenu-details][open]').forEach(function(d) {
        positionSubmenu(d);
      });
    }, 100);
  });
})();

/* === STICKY NAV ON SCROLL === */
(function() {
  if (window.innerWidth < 768) return;

  var navWrapper = document.querySelector('.site-navigation-wrapper');
  var headerMain = document.querySelector('.site-header-main');
  if (!navWrapper || !headerMain) return;

  // Create placeholder to prevent content jump when nav becomes fixed
  var placeholder = document.createElement('div');
  placeholder.style.display = 'none';
  navWrapper.parentNode.insertBefore(placeholder, navWrapper.nextSibling);

  var isSticky = false;

  function handleScroll() {
    var triggerPoint = headerMain.getBoundingClientRect().bottom;

    if (triggerPoint <= 0 && !isSticky) {
      placeholder.style.display = 'block';
      placeholder.style.height = navWrapper.offsetHeight + 'px';
      navWrapper.classList.add('is-sticky');
      isSticky = true;
    } else if (triggerPoint > 0 && isSticky) {
      navWrapper.classList.remove('is-sticky');
      placeholder.style.display = 'none';
      isSticky = false;
    }
  }

  window.addEventListener('scroll', handleScroll, { passive: true });
  window.addEventListener('resize', function() {
    if (window.innerWidth < 768 && isSticky) {
      navWrapper.classList.remove('is-sticky');
      placeholder.style.display = 'none';
      isSticky = false;
    }
  });
})();

/* === MOBILE PRODUCT GALLERY SWIPE OVERRIDE ===
   Empire's native gallery swipe is too sensitive on mobile and triggers
   image changes during normal vertical scrolling. This intercepts touch
   events on the gallery viewer in the capture phase, blocks Empire's own
   handlers, and implements a higher-threshold swipe with a strong
   horizontal-vs-vertical bias check. Navigation is performed by clicking
   the matching thumbnail (which Empire wires up reliably).
   Index is tracked internally — DOM reads of aria-hidden proved unreliable
   on mobile during Empire's crossfade transitions. A MutationObserver on
   thumbnails keeps the internal index in sync if the user taps a thumb
   directly. */
(function() {
  // Mobile only — desktop gallery behavior is fine.
  if (window.innerWidth >= 720) return;

  // Tunables
  var MIN_HORIZONTAL_TRAVEL = 35; // px the finger must travel horizontally
  var HORIZONTAL_BIAS = 1.3;      // |dx| must exceed |dy| * this to count
  var MAX_VERTICAL_DRIFT = 55;    // if |dy| exceeds this before commit, abort
  var NAV_COOLDOWN = 350;         // ms to wait after navigating before accepting new swipe

  var startX = 0;
  var startY = 0;
  var tracking = false;
  var aborted = false;
  var activeViewer = null;
  var currentIndex = 0;           // pure internal tracking
  var totalSlides = 0;
  var lastNavTime = 0;
  var initialized = false;

  function getViewerFromTarget(target) {
    if (!target || !target.closest) return null;
    return target.closest('.product-gallery--viewer, [data-gallery-viewer]');
  }

  /* Always re-query for fresh thumbnail references */
  function getFreshThumbnails() {
    var gallery = document.querySelector('.product-gallery');
    if (!gallery) return [];
    return gallery.querySelectorAll('.product-gallery--media-thumbnail');
  }

  /* Try multiple strategies to read current index from DOM */
  function readCurrentIndexFromDOM() {
    var viewer = document.querySelector('.product-gallery--viewer, [data-gallery-viewer]');
    if (!viewer) return 0;
    var slides = viewer.querySelectorAll('.product-gallery--media');
    totalSlides = slides.length;

    // Strategy 1: aria-hidden="false"
    for (var i = 0; i < slides.length; i++) {
      if (slides[i].getAttribute('aria-hidden') === 'false') return i;
    }
    // Strategy 2: position:static (active slide is static, others absolute)
    for (var i = 0; i < slides.length; i++) {
      if (window.getComputedStyle(slides[i]).position === 'static') return i;
    }
    // Strategy 3: visibility:visible
    for (var i = 0; i < slides.length; i++) {
      if (window.getComputedStyle(slides[i]).visibility === 'visible') return i;
    }
    return 0;
  }

  /* Initialize once: read from DOM and set up observer on thumbnails */
  function init() {
    if (initialized) return;
    initialized = true;
    currentIndex = readCurrentIndexFromDOM();
    var thumbs = getFreshThumbnails();
    totalSlides = thumbs.length;

    // Watch for thumbnail clicks by the user (not from our code).
    // When Empire updates aria-hidden on slides, sync our index.
    var viewer = document.querySelector('.product-gallery--viewer, [data-gallery-viewer]');
    if (viewer) {
      var obs = new MutationObserver(function() {
        // Only sync if we haven't navigated recently (avoids reading mid-transition)
        if (Date.now() - lastNavTime > 800) {
          var idx = readCurrentIndexFromDOM();
          if (idx !== currentIndex) currentIndex = idx;
        }
      });
      obs.observe(viewer, { attributes: true, attributeFilter: ['aria-hidden'], subtree: true });
    }
  }

  function navigate(direction) {
    var now = Date.now();
    if (now - lastNavTime < NAV_COOLDOWN) return;

    var thumbs = getFreshThumbnails();
    if (!thumbs.length) return;
    totalSlides = thumbs.length;

    var next = currentIndex + direction;
    if (next < 0 || next >= totalSlides) return; // no wrap

    lastNavTime = now;
    currentIndex = next;
    thumbs[next].click();
  }

  function onTouchStart(e) {
    var viewer = getViewerFromTarget(e.target);
    if (!viewer) return;

    // First touch: initialize from DOM
    init();

    // Block Empire's own listeners
    e.stopImmediatePropagation();

    activeViewer = viewer;
    tracking = true;
    aborted = false;
    var t = e.touches[0];
    startX = t.clientX;
    startY = t.clientY;
  }

  function onTouchMove(e) {
    if (!tracking) return;
    var viewer = getViewerFromTarget(e.target);
    if (viewer || activeViewer) e.stopImmediatePropagation();
    if (aborted) return;

    var t = e.touches[0];
    var dx = t.clientX - startX;
    var dy = t.clientY - startY;
    var adx = Math.abs(dx);
    var ady = Math.abs(dy);

    // If the gesture is clearly vertical, abort: let the page scroll.
    if (ady > MAX_VERTICAL_DRIFT && ady > adx) {
      aborted = true;
      tracking = false;
      activeViewer = null;
      return;
    }

    // If clearly horizontal, prevent the page from scrolling sideways.
    if (adx > 10 && adx > ady * HORIZONTAL_BIAS) {
      if (e.cancelable) e.preventDefault();
    }
  }

  function onTouchEnd(e) {
    if (!tracking) {
      activeViewer = null;
      return;
    }
    tracking = false;
    activeViewer = null;
    if (aborted) return;

    // Block Empire's touchend
    e.stopImmediatePropagation();

    var changed = e.changedTouches && e.changedTouches[0];
    if (!changed) return;
    var dx = changed.clientX - startX;
    var dy = changed.clientY - startY;
    var adx = Math.abs(dx);
    var ady = Math.abs(dy);

    if (adx >= MIN_HORIZONTAL_TRAVEL && adx > ady * HORIZONTAL_BIAS) {
      navigate(dx < 0 ? 1 : -1);
    }
  }

  function onTouchCancel(e) {
    if (tracking) e.stopImmediatePropagation();
    tracking = false;
    aborted = false;
    activeViewer = null;
  }

  // Capture phase on window — passive:false lets us call preventDefault
  var opts = { capture: true, passive: false };
  window.addEventListener('touchstart', onTouchStart, opts);
  window.addEventListener('touchmove', onTouchMove, opts);
  window.addEventListener('touchend', onTouchEnd, opts);
  window.addEventListener('touchcancel', onTouchCancel, opts);
})();


/* === CART LINE TOTAL FIX ===
   BCPO (Better Custom Product Options) wraps cart prices in
   .bcpo-cart-item-price (unit) and .bcpo-cart-item-line-price (line total).
   The line-price element just echoes the unit price instead of
   multiplying by quantity. This IIFE reads the unit price, reads the
   quantity input, calculates the real line total, and writes it back.
   A MutationObserver + input listener keeps it in sync when the
   customer changes qty. */
(function() {
  'use strict';

  /* Parse a price string like "$7,499.00" → 7499.00 */
  function parsePrice(str) {
    if (!str) return 0;
    var cleaned = str.replace(/[^0-9.\-]/g, '');
    return parseFloat(cleaned) || 0;
  }

  /* Format a number back to "$X,XXX.XX" */
  function formatPrice(num) {
    return '$' + num.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  /* Update one cart item's line total */
  function updateLineTotal(cartItem) {
    /* --- Find unit price --- */
    var unitEl = cartItem.querySelector('.bcpo-cart-item-price');
    /* Fallback: if BCPO isn't wrapping, try theme's own price element */
    if (!unitEl) {
      unitEl = cartItem.querySelector('.cart-item--price [data-cart-item-price]');
    }
    if (!unitEl) return;

    var unitPrice = parsePrice(unitEl.textContent);
    if (unitPrice <= 0) return;

    /* --- Find quantity --- */
    var qtyInput = cartItem.querySelector('.quantity-selector__input, input[name="updates[]"]');
    if (!qtyInput) return;
    var qty = parseInt(qtyInput.value, 10) || 1;

    /* --- Find line total element --- */
    var lineEl = cartItem.querySelector('.bcpo-cart-item-line-price');
    /* Fallback: theme's own line price */
    if (!lineEl) {
      lineEl = cartItem.querySelector('.cart-item--total [data-cart-item-total]');
    }
    if (!lineEl) return;

    /* --- Write the calculated total --- */
    var lineTotal = unitPrice * qty;
    lineEl.textContent = formatPrice(lineTotal);
  }

  /* Process all cart items on the page */
  function updateAllLineTotals() {
    var items = document.querySelectorAll('.cart-item');
    items.forEach(updateLineTotal);
  }

  /* Wait for DOM to be ready (cart may load async) */
  function init() {
    var items = document.querySelectorAll('.cart-item');
    if (!items.length) return; // not on the cart page

    updateAllLineTotals();

    /* Listen for quantity changes via input/change events */
    items.forEach(function(item) {
      var qtyInput = item.querySelector('.quantity-selector__input, input[name="updates[]"]');
      if (!qtyInput) return;

      qtyInput.addEventListener('input', function() {
        updateLineTotal(item);
      });
      qtyInput.addEventListener('change', function() {
        updateLineTotal(item);
      });
    });

    /* Also listen for +/- button clicks which may not fire input events
       immediately. Watch for value attribute changes on qty inputs. */
    items.forEach(function(item) {
      var qtyInput = item.querySelector('.quantity-selector__input, input[name="updates[]"]');
      if (!qtyInput) return;

      var obs = new MutationObserver(function() {
        updateLineTotal(item);
      });
      obs.observe(qtyInput, { attributes: true, attributeFilter: ['value'] });

      /* Also catch +/- buttons directly */
      var btns = item.querySelectorAll('.quantity-selector__button, .quantity-selector button');
      btns.forEach(function(btn) {
        btn.addEventListener('click', function() {
          /* Small delay to let the theme update the input value */
          setTimeout(function() { updateLineTotal(item); }, 150);
        });
      });
    });

    /* MutationObserver on the cart list for AJAX cart updates
       (Empire reloads cart items via fetch on qty change) */
    var cartList = document.querySelector('.cartitems--list');
    if (cartList) {
      var listObs = new MutationObserver(function() {
        /* Re-run after a tick to let new DOM settle */
        setTimeout(function() {
          updateAllLineTotals();
          bindNewItems();
        }, 300);
      });
      listObs.observe(cartList, { childList: true, subtree: true });
    }
  }

  /* Re-bind event listeners after AJAX cart reload */
  function bindNewItems() {
    var items = document.querySelectorAll('.cart-item');
    items.forEach(function(item) {
      if (item.dataset.lineTotalBound) return;
      item.dataset.lineTotalBound = '1';

      var qtyInput = item.querySelector('.quantity-selector__input, input[name="updates[]"]');
      if (!qtyInput) return;

      qtyInput.addEventListener('input', function() { updateLineTotal(item); });
      qtyInput.addEventListener('change', function() { updateLineTotal(item); });

      var obs = new MutationObserver(function() { updateLineTotal(item); });
      obs.observe(qtyInput, { attributes: true, attributeFilter: ['value'] });

      var btns = item.querySelectorAll('.quantity-selector__button, .quantity-selector button');
      btns.forEach(function(btn) {
        btn.addEventListener('click', function() {
          setTimeout(function() { updateLineTotal(item); }, 150);
        });
      });
    });
  }

  /* Run on DOMContentLoaded or immediately if already loaded */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();


/* === QUOTIFY BUTTON REORDER (ALL VIEWPORTS) ===
   Quotify's "Request a Quote" button lives in its own
   shopify-section in <main>, outside the cart form:

     main#site-main
       div.shopify-section.cart--section   ← cart form lives here
         form → section.cartitems--container
           div.cartitems → div.cart-total → div.cart-checkout
       div.shopify-section                 ← quotify lives here
         div.product-section--container
           div.shopify-block
             quotify-button
               button "Request a Quote"

   We move the quotify shopify-section into .cart-checkout.
   CSS order:-1 places it above the Checkout button.

   BATCH 3.8 — CSS ::BEFORE PLACEHOLDER + EAGER OBSERVER:
   Quotify loads asynchronously, so without intervention the
   Checkout button renders first, then visibly shifts DOWN when
   Request a Quote appears above it. To prevent this:
   - CSS adds a ::before pseudo-element to .cart-checkout with
     order:-1 and height:53px. This renders at FIRST PAINT,
     before any JS runs, reserving space above Checkout.
   - When Quotify loads and JS moves the real button in, JS adds
     .quotify-loaded to .cart-checkout, which hides the ::before.
   - CSS hides <quotify-button> everywhere except inside
     .cart-checkout, so no flash in the original location.

   SPEED: The MutationObserver starts IMMEDIATELY at script parse
   time on document.documentElement — it does NOT wait for
   DOMContentLoaded. This catches quotify-button the instant
   Quotify injects it into the DOM, shaving off the delay
   between script parse and DOMContentLoaded. */
(function() {
  'use strict';

  var moved = false;
  var obs = null;

  function getQuotifySection() {
    var el = document.querySelector('quotify-button');
    if (el) {
      var section = el.closest('.shopify-section');
      return section || el;
    }
    var btns = document.querySelectorAll('button');
    for (var i = 0; i < btns.length; i++) {
      if (/request\s+a\s+quote/i.test(btns[i].textContent)) {
        var section = btns[i].closest('.shopify-section');
        if (section && !section.querySelector('.cart-item')) {
          return section;
        }
      }
    }
    return null;
  }

  function moveToCart() {
    if (moved) return true;
    var quotifySection = getQuotifySection();
    var cartCheckout = document.querySelector('.cart-checkout');
    if (!quotifySection || !cartCheckout) return false;

    quotifySection.classList.add('quotify-moved');
    cartCheckout.appendChild(quotifySection);
    cartCheckout.classList.add('quotify-loaded');

    moved = true;
    if (obs) { obs.disconnect(); obs = null; }
    return true;
  }

  /* Try immediately — in case both elements already exist */
  if (moveToCart()) return;

  /* Start observing the ENTIRE document tree right now —
     don't wait for DOMContentLoaded. This fires the callback
     the instant Quotify injects its element. */
  obs = new MutationObserver(function() {
    moveToCart();
  });
  obs.observe(document.documentElement, { childList: true, subtree: true });

  /* Safety: disconnect after 15s to avoid leaking the observer */
  setTimeout(function() { if (obs) { obs.disconnect(); obs = null; } }, 15000);
})();


/* === MOBILE MENU ACCORDION (IIFE 6) ===
   Empire's mobile menu (#site-mobile-nav) allows multiple submenus
   to be open at once. This IIFE makes it accordion-style: opening
   one top-level category auto-closes any other open category.

   BATCH 4.6 APPROACH — Capture-phase click + dual state check:
   Uses CAPTURE phase listener so we see clicks before Empire can
   stopPropagation(). After a 250ms delay (for Empire to update
   state), checks BOTH aria-expanded AND data-accordion-state to
   determine open/closed — belt-and-suspenders for reliability.

   Also adds a MutationObserver fallback: if clicks are somehow
   missed, we watch aria-expanded changes on all top-level triggers
   and enforce accordion behavior from there.

   MOBILE-ONLY: Guarded by window.innerWidth <= 719 so it never
   conflicts with IIFE 1 (desktop click-to-open). */
(function() {
  'use strict';

  var MOBILE_MAX = 719;
  var closing = false;

  /* Check if a top-level menu item is open using multiple signals */
  function isItemOpen(item) {
    var trigger = item.querySelector(':scope > [data-navmenu-trigger]');
    if (trigger && trigger.getAttribute('aria-expanded') === 'true') return true;
    var content = item.querySelector(':scope > [data-accordion-content]');
    if (content && content.getAttribute('data-accordion-state') === 'open') return true;
    /* Also check the mega-nav wrapper which is a direct child */
    var mega = item.querySelector(':scope > .navmenu-submenu, :scope > .navmenu-meganav');
    if (mega && mega.getAttribute('data-accordion-state') === 'open') return true;
    return false;
  }

  /* Close all open siblings of the given item */
  function closeSiblings(depth1, openedItem) {
    if (closing) return;
    closing = true;

    var siblings = depth1.querySelectorAll(':scope > .navmenu-item-parent');
    for (var i = 0; i < siblings.length; i++) {
      if (siblings[i] === openedItem) continue;
      if (!isItemOpen(siblings[i])) continue;

      var sibTrigger = siblings[i].querySelector(':scope > [data-navmenu-trigger]');
      if (sibTrigger) {
        sibTrigger.click();
      }
    }

    /* Hold guard for Empire's close animation (200ms transition
       + transitionend cleanup). 600ms gives safe margin. */
    setTimeout(function() { closing = false; }, 600);
  }

  function init() {
    var mobileNav = document.getElementById('site-mobile-nav');
    if (!mobileNav) return;

    var depth1 = mobileNav.querySelector('.navmenu-depth-1');
    if (!depth1) return;

    /* --- PRIMARY: Capture-phase click listener ---
       Capture phase ensures we see clicks even if Empire calls
       stopPropagation() in a bubble-phase handler. */
    mobileNav.addEventListener('click', function(e) {
      if (window.innerWidth > MOBILE_MAX) return;
      if (closing) return;

      /* Only act on top-level link or chevron trigger clicks */
      var hit = e.target.closest(
        '.navmenu-depth-1 > .navmenu-item-parent > .navmenu-link-parent,' +
        '.navmenu-depth-1 > .navmenu-item-parent > [data-navmenu-trigger]'
      );
      if (!hit) return;

      var openedItem = hit.closest('.navmenu-item-parent');
      if (!openedItem || openedItem.parentElement !== depth1) return;

      /* Wait for Empire to process the click and update state.
         250ms is enough for Empire's synchronous attribute update
         and short enough to feel instant to the user. */
      setTimeout(function() {
        if (closing) return;
        if (!isItemOpen(openedItem)) return;
        closeSiblings(depth1, openedItem);
      }, 250);
    }, true); /* ← CAPTURE PHASE */

    /* --- FALLBACK: MutationObserver on aria-expanded ---
       If clicks are missed for any reason, this catches state
       changes directly. Watches all top-level trigger buttons. */
    var triggers = depth1.querySelectorAll(
      ':scope > .navmenu-item-parent > [data-navmenu-trigger]'
    );
    if (triggers.length > 0) {
      var obs = new MutationObserver(function(mutations) {
        if (window.innerWidth > MOBILE_MAX) return;
        if (closing) return;

        for (var m = 0; m < mutations.length; m++) {
          var trigger = mutations[m].target;
          if (trigger.getAttribute('aria-expanded') !== 'true') continue;

          var openedItem = trigger.closest('.navmenu-item-parent');
          if (!openedItem || openedItem.parentElement !== depth1) continue;

          /* Small delay to batch rapid mutations */
          setTimeout(function(item) {
            if (closing) return;
            if (!isItemOpen(item)) return;
            closeSiblings(depth1, item);
          }.bind(null, openedItem), 100);
          break; /* Only handle the first "opened" mutation */
        }
      });

      for (var i = 0; i < triggers.length; i++) {
        obs.observe(triggers[i], {
          attributes: true,
          attributeFilter: ['aria-expanded']
        });
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();


/* === PRODUCT DESCRIPTION TAB MARKER (IIFE 7) ===
   Empire's collapsible product tabs (<details class="collapsible-tab">)
   have no unique identifiers — all tabs share the same class, no IDs,
   no data-attributes. CSS alone cannot target the Product Description
   tab differently from Warranty, Freight, etc.

   This IIFE marks every collapsible tab whose <summary> text matches
   "PRODUCT DESCRIPTION" (or just "DESCRIPTION") with the class
   .collapsible-tab--description. CSS in Section 16 then targets this
   class for:
   - Sticky heading on open (position:sticky, white bg, shadow)
   - Scrollable content area (max-height:70vh, overflow-y:auto)
   - Visible styled scrollbar
   Other tabs (Warranty, Freight, etc.) remain unaffected.

   A MutationObserver watches for late-loading Shopify sections that
   might inject tabs after DOMContentLoaded (e.g. AJAX section
   rendering). It disconnects after 10s to avoid leaks. */
(function() {
  'use strict';

  var CLASS = 'collapsible-tab--description';

  function markDescriptionTabs() {
    var tabs = document.querySelectorAll('.collapsible-tab');
    for (var i = 0; i < tabs.length; i++) {
      var summary = tabs[i].querySelector('summary');
      if (!summary) continue;
      var text = summary.textContent.trim().toUpperCase();
      if (text === 'PRODUCT DESCRIPTION' || text === 'DESCRIPTION') {
        if (!tabs[i].classList.contains(CLASS)) {
          tabs[i].classList.add(CLASS);
        }
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', markDescriptionTabs);
  } else {
    markDescriptionTabs();
  }

  /* Watch for late-loading sections */
  var obs = new MutationObserver(markDescriptionTabs);
  obs.observe(document.documentElement, { childList: true, subtree: true });
  setTimeout(function() { obs.disconnect(); }, 10000);
})();


/* === REVIEWS PAGE — TITLE RENAME (IIFE 8) ===
   Only runs on /pages/reviews.
   Renames the page title from "Customer Reviews" to
   "Recent Customer Reviews".
   Name capitalization is handled via CSS (text-transform:
   capitalize on .junip-review-author) to avoid conflicts
   with Junip's async re-rendering. */
(function() {
  'use strict';

  if (window.location.pathname !== '/pages/reviews') return;

  function renameTitle() {
    var title = document.querySelector('.page-title');
    if (title && title.textContent.trim() === 'Customer Reviews') {
      title.textContent = 'Recent Customer Reviews';
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', renameTitle);
  } else {
    renameTitle();
  }
})();

/* === ABOUT US PAGE — SCOPE CLASS (IIFE 9) ===
   Only runs on /pages/about-us.
   Adds .about-us class to .site-page so CSS Section 27
   can scope its card styling to this page only. */
(function() {
  'use strict';
  if (window.location.pathname !== '/pages/about-us') return;
  var sitePage = document.querySelector('.site-page');
  if (sitePage) sitePage.classList.add('about-us');
})();

/* === SHIPPING POLICY PAGE — SCOPE CLASS (IIFE 10) ===
   Only runs on /policies/shipping-policy.
   Adds .shipping-policy class to .shopify-policy__container
   so CSS Section 28 can scope its card styling to this page only. */
(function() {
  'use strict';
  if (window.location.pathname !== '/policies/shipping-policy') return;
  var container = document.querySelector('.shopify-policy__container');
  if (container) container.classList.add('shipping-policy');
})();

/* === FAQ PAGE — SCOPE CLASS (IIFE 11) ===
   Only runs on /pages/faq.
   Adds .faq-page class to .site-page so CSS Section 29
   can scope its card styling to this page only. */
(function() {
  'use strict';
  if (window.location.pathname !== '/pages/faq') return;
  var sitePage = document.querySelector('.site-page');
  if (sitePage) sitePage.classList.add('faq-page');
})();

/* === REFUND POLICY PAGE — SCOPE CLASS (IIFE 12) ===
   Only runs on /policies/refund-policy.
   Adds .refund-policy class to .shopify-policy__container
   so CSS Section 30 can scope its card styling to this page only. */
(function() {
  'use strict';
  if (window.location.pathname !== '/policies/refund-policy') return;
  var container = document.querySelector('.shopify-policy__container');
  if (container) container.classList.add('refund-policy');
})();

/* === WARRANTY PAGE — SCOPE CLASS (IIFE 13) ===
   Only runs on /pages/warranty.
   Adds .warranty-page class to .site-page so CSS Section 31
   can scope its card styling to this page only. */
(function() {
  'use strict';
  if (window.location.pathname !== '/pages/warranty') return;
  var sitePage = document.querySelector('.site-page');
  if (sitePage) sitePage.classList.add('warranty-page');
})();

/* === PAYMENT POLICY PAGE — SCOPE CLASS (IIFE 14) ===
   Only runs on /pages/payment-policy.
   Adds .payment-policy-page class to .site-page so CSS Section 32
   can scope its card styling to this page only. */
(function() {
  'use strict';
  if (window.location.pathname !== '/pages/payment-policy') return;
  var sitePage = document.querySelector('.site-page');
  if (sitePage) sitePage.classList.add('payment-policy-page');
})();

/* === TERMS OF SERVICE PAGE — SCOPE CLASS (IIFE 15) ===
   Only runs on /policies/terms-of-service.
   Adds .terms-of-service class to .shopify-policy__container so CSS Section 33
   can scope its card styling to this page only. */
(function() {
  'use strict';
  if (window.location.pathname !== '/policies/terms-of-service') return;
  var container = document.querySelector('.shopify-policy__container');
  if (container) container.classList.add('terms-of-service');
})();

/* === PRIVACY POLICY PAGE — SCOPE CLASS (IIFE 16) ===
   Only runs on /policies/privacy-policy.
   Adds .privacy-policy class to .shopify-policy__container so CSS Section 34
   can scope its card styling to this page only. */
(function() {
  'use strict';
  if (window.location.pathname !== '/policies/privacy-policy') return;
  var container = document.querySelector('.shopify-policy__container');
  if (container) container.classList.add('privacy-policy');
})();

/* === DISCLAIMER PAGE — SCOPE CLASS (IIFE 17) ===
   Only runs on /pages/disclaimer.
   Adds .disclaimer-page class to .site-page so CSS Section 35
   can scope its card styling to this page only. */
(function() {
  'use strict';
  if (window.location.pathname !== '/pages/disclaimer') return;
  var sitePage = document.querySelector('.site-page');
  if (sitePage) sitePage.classList.add('disclaimer-page');
})();

/* === WHY BUY FROM US PAGE — REVIEWS CLEANUP (IIFE 18) ===
   Only runs on /pages/why-buy-from-us.
   1. Renames "What Our Customers Say" → "Recent Customer Reviews"
   2. Formats .junip-customer-name to "FirstName L." (first name + last initial)
   3. Hides "37 reviews" count (also handled via CSS as backup)
   Uses MutationObserver to catch Junip reviews loading asynchronously. */
(function() {
  'use strict';
  if (window.location.pathname !== '/pages/why-buy-from-us') return;

  /* --- Rename reviews title --- */
  var title = document.querySelector('.reviews-title');
  if (title) title.textContent = 'Recent Customer Reviews';

  /* --- Format reviewer names: "FirstName L." --- */
  function formatNames() {
    var names = document.querySelectorAll('.why-buy-enhanced .junip-customer-name');
    for (var i = 0; i < names.length; i++) {
      var raw = names[i].textContent.trim();
      if (names[i].getAttribute('data-formatted')) continue;
      var parts = raw.split(/\s+/);
      if (parts.length >= 2) {
        var first = parts[0].charAt(0).toUpperCase() + parts[0].slice(1).toLowerCase();
        var lastInit = parts[parts.length - 1].charAt(0).toUpperCase() + '.';
        names[i].textContent = first + ' ' + lastInit;
      }
      names[i].setAttribute('data-formatted', 'true');
    }
  }
  formatNames();

  /* --- Hide review count (CSS backup) --- */
  var countEl = document.querySelector('.why-buy-enhanced .junip-product-review-count');
  if (countEl) countEl.style.display = 'none';

  /* --- Rename CTA link text (keep arrow) --- */
  var ctas = document.querySelectorAll('.why-buy-enhanced .feature-link-btn');
  for (var c = 0; c < ctas.length; c++) {
    if (ctas[c].textContent.indexOf('Learn About Installation') !== -1) {
      ctas[c].innerHTML = 'More About Installation &nbsp;<span style="font-size:1.3em;vertical-align:middle;">&rarr;</span>';
    }
  }

  /* --- MutationObserver for async-loaded Junip content --- */
  var reviewsSection = document.querySelector('.why-buy-enhanced .reviews-section');
  if (reviewsSection) {
    var observer = new MutationObserver(function() {
      formatNames();
      var cnt = document.querySelector('.why-buy-enhanced .junip-product-review-count');
      if (cnt) cnt.style.display = 'none';
    });
    observer.observe(reviewsSection, { childList: true, subtree: true });
  }
})();

/* ====================================================================
   IIFE 19 (REPLACEMENT v3) — REQUEST A QUOTE PAGE
   S46 revision (2026-08-22, panel green-lit). Page content is static
   HTML (see request-a-quote-page-v5.html); this script only:
   1. Adds the .request-quote-page scope class (Section 37/42/43/44 CSS
      keys on it). Normally the page body's inline FOUC-guard script has
      already done this during parse; this add is the idempotent
      fallback if that tag is ever stripped.
   2. Cart CTA — gated on CART STATE, not the referrer (v2 gated on
      referrer === /cart, which hid the button on direct/menu arrivals;
      owner-reported). Always fetches /cart.js; if item_count >= 1,
      inserts a green button with the live count into #quote-step2-slot
      (inside step 2 — the button IS step 2's action). $0 quote-only
      items count toward item_count, so quote-only carts get the button.
      Referrer only softens the label (came from /cart -> "Back to").
   3. Back-link — referrer-gated as before: same-origin /collections/,
      /products/, /search arrivals get a small "Back to {Category}" pill
      in the top #quote-cta-slot. A /cart referrer no longer produces a
      top button (its job moved into step 2).
   Styling lives in Section 46 (classes .quote-step2-cta /
   .quote-back-link) — no inline style attributes here anymore.
   Progressive enhancement: every failure path (no fetch, non-2xx, bad
   JSON, item_count missing, empty cart, slot missing, malformed
   referrer) leaves the static page standing exactly as pasted.
   ==================================================================== */
(function() {
  'use strict';
  if (window.location.pathname !== '/pages/request-a-quote') return;

  /* --- 1. Scope class (fallback add; inline body script is primary) --- */
  var sitePage = document.querySelector('.site-page');
  if (sitePage) sitePage.classList.add('request-quote-page');

  /* --- Shared referrer parse: same-origin, non-self, else null --- */
  var ref = null;
  if (document.referrer) {
    try {
      var u = new URL(document.referrer);
      if (u.origin === window.location.origin &&
          u.pathname !== '/pages/request-a-quote') ref = u;
    } catch (e) { /* malformed referrer: treat as none */ }
  }

  /* --- 2. Cart CTA in step 2 — cart-state gated --- */
  var step2Slot = document.getElementById('quote-step2-slot');
  if (step2Slot && ('fetch' in window)) {
    // no-store closes the stale-cache edge on reloads.
    fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (cart) {
        if (!cart || typeof cart.item_count !== 'number' || cart.item_count < 1) return;
        if (!step2Slot.isConnected ||
            step2Slot.querySelector('[data-quote-cart-cta]')) return; // dedup on re-run
        var n = cart.item_count;
        var verb = (ref && ref.pathname === '/cart') ? 'Back to your cart' : 'Open your cart';
        var a = document.createElement('a');
        a.href = '/cart';
        a.className = 'quote-step2-cta';
        a.setAttribute('data-quote-cart-cta', '');
        a.textContent = verb + ' (' + n + (n === 1 ? ' item' : ' items') + ') →';
        step2Slot.appendChild(a);
      })
      .catch(function () { /* network/JSON failure: page stands as-is */ });
  }

  /* --- 3. Referrer back-link (top slot) — shopping pages only --- */
  var slot = document.getElementById('quote-cta-slot');
  if (!slot || !ref) return;
  var path = ref.pathname;
  if (/^\/(collections|products)\//.test(path) || path === '/search') {
    if (slot.querySelector('[data-quote-referrer-cta]')) return;
    var seg = path.split('/').filter(Boolean).pop() || '';
    seg = seg.replace(/-for-sale$/, '').replace(/-/g, ' ');
    seg = seg.replace(/\b\w/g, function (c) { return c.toUpperCase(); });
    var label = (path === '/search' || !seg || seg.length > 28)
      ? '← Back to shopping'
      : '← Back to ' + seg;
    var b = document.createElement('a');
    b.href = ref.href; // full URL preserves filters/pagination/variant params
    b.className = 'quote-back-link';
    b.setAttribute('data-quote-referrer-cta', '');
    b.textContent = label;
    slot.appendChild(b);
  }
  /* internal non-shopping or no referrer: top slot stays empty */
})();


/* === IIFE 20 — COLLECTION FILTERS: CLEAN UP & REORDER ============
   Five jobs on collection pages:
   A) Remove "phantom" sidebars injected by stale collection
      descriptions (86 collections have sidebar HTML pasted into their
      description field, creating a duplicate empty .productgrid--sidebar
      that breaks Empire's accordion init and mobile filter drawer).
   B) If Empire's accordion failed to initialise on the real sidebar
      (no --menu-open-height measured), manually bootstrap it: measure
      each filter group's height, set data-accordion-state, and attach
      click handlers so the accordion toggle works.
   C) Hide any filter group with <= 1 selectable option (all viewports).
   D) Move Manufacturer to the first position if present.
   E) Collapse all filter groups on initial page load.
   F) Hide the "Filters" heading (desktop) and "Filters" button (mobile)
      when no filter groups remain visible after (C).

   Empire DOM (per filter group):
     .productgrid--sidebar-group
       > button.productgrid--sidebar-button  (heading / accordion trigger)
       > ul.filter-group[data-accordion-content][data-accordion-state]
           > li.filter-item  (each selectable option)
           > li.filter-item--toggle-more  ("See more" — excluded from count)

   Empire accordion CSS (theme.css):
     [data-accordion-content][data-accordion-state]          → display:none
     [data-accordion-content][data-accordion-state="open"]   → display:block

   Visibility is driven by the data-accordion-state attribute ("open" or
   "closed"), NOT by the filter-group-active CSS class alone.

   All groups sit inside a <nav> that is a child of
   .productgrid--sidebar-section > .productgrid--sidebar.

   IMPORTANT: A re-entrancy guard prevents the MutationObserver from
   triggering an infinite loop when moveManufacturerFirst() moves DOM
   nodes, which previously crashed Empire's JS and broke mobile filters.
   ================================================================== */
(function () {
  'use strict';

  var isUpdating = false;    /* re-entrancy guard for MutationObserver */
  var hasCollapsed = false;   /* collapse only once on initial load    */
  var hasBootstrapped = false; /* accordion bootstrap only once        */

  /* --- A: Remove phantom sidebars --------------------------------
     Some collection descriptions contain accidentally pasted HTML
     that includes a full .productgrid--sidebar structure with an
     empty <nav>.  This phantom appears BEFORE the real sidebar in
     the DOM, so Empire's querySelector finds it first and fails to
     initialise the accordion on the real one.  We remove any sidebar
     element that contains zero .productgrid--sidebar-group children.
     ---------------------------------------------------------------- */
  function removePhantomSidebars() {
    var sidebars = document.querySelectorAll('.productgrid--sidebar');
    if (sidebars.length <= 1) return;          /* nothing to clean up */

    sidebars.forEach(function (sb) {
      if (sb.querySelectorAll('.productgrid--sidebar-group').length === 0) {
        sb.remove();
      }
    });
  }

  /* --- B: Bootstrap accordion if Empire failed -------------------
     When a phantom sidebar was present at load-time, Empire measured
     heights and attached click handlers on the empty phantom instead
     of the real filter groups.  This function detects that situation
     (no --menu-open-height on any list) and does the same work:
       1. Temporarily display each list to measure its natural height.
       2. Store the height in --menu-open-height.
       3. Set data-accordion-state = "closed".
       4. Add a click handler on each button for accordion toggle.
     On pages where Empire already initialised correctly this function
     exits immediately without touching anything.
     ---------------------------------------------------------------- */
  function bootstrapAccordion() {
    if (hasBootstrapped) return;

    var lists = document.querySelectorAll(
      '.filter-group[data-accordion-content]'
    );
    if (!lists.length) return;

    /* Check whether Empire already did its job */
    var alreadyInit = false;
    lists.forEach(function (l) {
      if (l.getAttribute('data-accordion-state') &&
          l.style.getPropertyValue('--menu-open-height')) {
        alreadyInit = true;
      }
    });
    if (alreadyInit) return;

    hasBootstrapped = true;

    lists.forEach(function (list) {
      var group = list.closest('.productgrid--sidebar-group');
      var btn = group
        ? group.querySelector('.productgrid--sidebar-button')
        : null;

      /* Measure the list's natural (expanded) height */
      var origDisplay = getComputedStyle(list).display;
      list.style.display = 'block';
      list.style.height = 'auto';
      var naturalHeight = list.scrollHeight;
      list.style.display = '';
      list.style.height = '';

      /* Set Empire-compatible attributes */
      list.style.setProperty('--menu-open-height', naturalHeight + 'px');
      list.setAttribute('data-accordion-state', 'closed');

      if (btn) {
        btn.setAttribute('aria-expanded', 'false');
        btn.classList.remove('productgrid--sidebar-button-active');

        /* Replicate Empire's accordion toggle on click */
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          /* Stop the click from bubbling up to Empire's delegated
             handler on a parent element — without this, both Empire's
             handler and ours fire, double-toggling the accordion. */
          e.stopPropagation();

          var isOpen =
            list.getAttribute('data-accordion-state') === 'open';

          if (isOpen) {
            list.setAttribute('data-accordion-state', 'closed');
            list.classList.remove('filter-group-active');
            btn.setAttribute('aria-expanded', 'false');
            btn.classList.remove('productgrid--sidebar-button-active');
          } else {
            list.setAttribute('data-accordion-state', 'open');
            list.classList.add('filter-group-active');
            btn.setAttribute('aria-expanded', 'true');
            btn.classList.add('productgrid--sidebar-button-active');
          }
        });
      }
    });
  }

  /* --- C: Hide single-option groups ------------------------------ */
  function hideSingleOptionFilters() {
    var groups = document.querySelectorAll('.productgrid--sidebar-group');
    if (!groups.length) return;

    groups.forEach(function (group) {
      var items = group.querySelectorAll(
        '.filter-item:not(.filter-item--toggle-more)'
      );
      if (items.length <= 1) {
        group.style.display = 'none';
      } else {
        group.style.display = '';
      }
    });
  }

  /* --- D: Move "Manufacturer" group to first position ------------ */
  function moveManufacturerFirst() {
    var groups = document.querySelectorAll('.productgrid--sidebar-group');
    if (!groups.length) return;

    var parent = groups[0].parentElement;          /* the <nav> wrapper */
    var heading = parent.querySelector('.productgrid--sidebar-title');
    var mfgGroup = null;

    groups.forEach(function (group) {
      var btn = group.querySelector('.productgrid--sidebar-button');
      if (btn && btn.textContent.trim() === 'Manufacturer') {
        mfgGroup = group;
      }
    });

    if (mfgGroup && mfgGroup !== groups[0]) {
      if (heading && heading.nextSibling) {
        parent.insertBefore(mfgGroup, heading.nextSibling);
      } else {
        parent.insertBefore(mfgGroup, parent.firstChild);
      }
    }
  }

  /* --- E: Collapse all filter groups on load --------------------- */
  function collapseAllGroups() {
    if (hasCollapsed) return;
    hasCollapsed = true;

    document.querySelectorAll('.productgrid--sidebar-group').forEach(
      function (group) {
        var btn = group.querySelector('.productgrid--sidebar-button');
        var list = group.querySelector('.filter-group');

        if (btn) {
          btn.classList.remove('productgrid--sidebar-button-active');
          btn.setAttribute('aria-expanded', 'false');
        }
        if (list) {
          list.classList.remove('filter-group-active');
          list.setAttribute('data-accordion-state', 'closed');
        }
      }
    );
  }

  /* --- F: Hide "Filters" heading / button if no groups visible --- */
  function hideFiltersHeadingIfEmpty() {
    var groups = document.querySelectorAll('.productgrid--sidebar-group');
    var anyVisible = false;

    groups.forEach(function (group) {
      if (group.style.display !== 'none') {
        anyVisible = true;
      }
    });

    /* Desktop: hide the H2 "Filters" heading inside the nav */
    var heading = document.querySelector('.productgrid--sidebar-title');
    if (heading) {
      heading.style.display = anyVisible ? '' : 'none';
    }

    /* Also hide the entire sidebar section on desktop when empty */
    var sidebarSection = document.querySelector(
      '.productgrid--sidebar-section'
    );
    if (sidebarSection) {
      sidebarSection.style.display = anyVisible ? '' : 'none';
    }

    /* Mobile: hide the "Filters" trigger button when empty */
    var mobileBtn = document.querySelector('.utils-filter-button');
    if (mobileBtn) {
      mobileBtn.style.display = anyVisible ? '' : 'none';
    }
  }

  /* --- Master run (guarded) -------------------------------------- */
  function run() {
    if (isUpdating) return;
    isUpdating = true;

    try {
      removePhantomSidebars();
      moveManufacturerFirst();
      hideSingleOptionFilters();
      hideFiltersHeadingIfEmpty();
    } finally {
      /* Release guard on next tick so the observer can react to
         genuine Empire-driven re-renders that happen afterward */
      setTimeout(function () { isUpdating = false; }, 0);
    }
  }

  /* --- Bootstrap ------------------------------------------------- */
  function init() {
    run();
    /* Empire's DOMContentLoaded listener was registered before ours
       (empire.js loads earlier in the page), so by the time init()
       fires Empire has already finished its accordion setup.  On
       phantom-affected pages Empire will have failed, so
       bootstrapAccordion() takes over.  On clean pages Empire already
       initialised and bootstrapAccordion() is a no-op.
       Everything runs synchronously — no delay — so the filters are
       ready the instant the user can interact with them. */
    bootstrapAccordion();
    collapseAllGroups();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Re-run on resize (viewport may cross mobile/desktop boundary) */
  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      hideSingleOptionFilters();
      hideFiltersHeadingIfEmpty();
    }, 150);
  });

  /* Re-run after Empire AJAX filter updates (sidebar re-renders).
     childList + subtree catches deep DOM replacements during AJAX.
     Attribute changes (e.g. user toggling accordion) don't fire
     because we don't set attributes:true — only node add/remove. */
  function observeSidebar() {
    var sidebar = document.querySelector('.productgrid--sidebar');
    if (!sidebar) return;

    var observer = new MutationObserver(function () {
      run();
    });
    observer.observe(sidebar, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeSidebar);
  } else {
    observeSidebar();
  }
})();


/* === IIFE 21 — SORT-BY CLEANUP: REMOVE OPTIONS & MOBILE CSS ========
   Two jobs on collection pages:
   A) Remove unwanted sort options from both the desktop <select> and
      the mobile modal list: Most relevant, Best selling,
      Date old→new, Date new→old.
   B) Inject polished mobile CSS for the Sort By modal so it looks
      clean on small screens (background, spacing, rounded corners,
      active-state highlight).
   =================================================================== */
(function () {
  'use strict';

  /* Values to remove from the sort controls */
  var REMOVE_VALUES = [
    'most-relevant',
    'best-selling',
    'created-ascending',
    'created-descending'
  ];

  /* --- A: Remove unwanted sort options ----------------------------- */
  function pruneDesktopSelect() {
    var select = document.getElementById('product_grid_sort');
    if (!select) return;
    REMOVE_VALUES.forEach(function (val) {
      var opt = select.querySelector('option[value="' + val + '"]');
      if (opt) opt.remove();
    });
  }

  function pruneMobileModal() {
    var items = document.querySelectorAll('.utils-sortby--modal-item');
    items.forEach(function (li) {
      var btn = li.querySelector('button[data-productgrid-trigger-sort-button]');
      if (btn && REMOVE_VALUES.indexOf(btn.value) !== -1) {
        li.remove();
      }
    });
  }

  /* --- B: Inject mobile CSS for the Sort By modal ------------------ */
  function injectMobileCSS() {
    if (document.getElementById('sortby-mobile-css')) return;

    var css = [
      /* ---- Sort-by modal button overrides ----
         The theme lumps .utils-sortby--modal-button into a giant
         compound selector shared with .button-primary, .product-form--atc-button,
         etc., giving it green/blue backgrounds.  !important is needed to
         override that global rule.  No media-query wrapper — the modal is
         only ever shown on mobile by Empire's own JS. */

      /* All modal buttons — plain text baseline */
      '.utils-sortby--modal-button,',
      '.utils-sortby--modal-button:hover,',
      '.utils-sortby--modal-button:focus {',
      '  display: block !important;',
      '  width: 100% !important;',
      '  text-align: left !important;',
      '  background: transparent !important;',
      '  color: #333 !important;',
      '  border: none !important;',
      '  border-bottom: 1px solid #eee !important;',
      '  padding: 12px 14px !important;',
      '  font-size: 15px !important;',
      '  font-weight: 400 !important;',
      '  cursor: pointer !important;',
      '  border-radius: 0 !important;',
      '  box-shadow: none !important;',
      '  text-transform: none !important;',
      '  letter-spacing: normal !important;',
      '  line-height: 1.4 !important;',
      '  transition: background .15s !important;',
      '}',

      /* Active / currently-selected sort — green highlight so the',
      '   user knows which sort is in effect */
      '.utils-sortby--modal-button.utils-sortby--modal-button--active,',
      '.utils-sortby--modal-button--active,',
      '.utils-sortby--modal-button--active:hover,',
      '.utils-sortby--modal-button--active:focus {',
      '  background: #3C9342 !important;',
      '  color: #fff !important;',
      '  font-weight: 600 !important;',
      '  border-bottom: 1px solid #eee !important;',
      '}',

      /* Last item — no bottom border */
      '.utils-sortby--modal-item:last-child .utils-sortby--modal-button,',
      '.utils-sortby--modal-item:last-child .utils-sortby--modal-button--active {',
      '  border-bottom: none !important;',
      '}',

      /* Tap / press feedback — green flash for non-active buttons */
      '.utils-sortby--modal-button:active {',
      '  background: #3C9342 !important;',
      '  color: #fff !important;',
      '}',

      /* Disabled attribute on active button — keep it visible */
      '.utils-sortby--modal-button[disabled] {',
      '  opacity: 1 !important;',
      '  pointer-events: auto !important;',
      '}',

      /* Modal container */
      '.utils-sortby--modal {',
      '  background: #fff !important;',
      '  border: 1px solid #ddd !important;',
      '  border-radius: 8px !important;',
      '  box-shadow: 0 4px 16px rgba(0,0,0,.12) !important;',
      '  padding: 12px 0 !important;',
      '  margin-top: 8px !important;',
      '  max-width: 300px !important;',
      '  position: absolute !important;',
      '  z-index: 100 !important;',
      '  right: 0 !important;',
      '}',

      /* Modal title */
      '.utils-sortby--modal-title {',
      '  font-size: 15px !important;',
      '  font-weight: 600 !important;',
      '  margin: 0 !important;',
      '  padding: 8px 14px 12px !important;',
      '  border-bottom: 1px solid #eee !important;',
      '}',

      /* Modal list */
      '.utils-sortby--modal-list {',
      '  list-style: none !important;',
      '  margin: 0 !important;',
      '  padding: 0 !important;',
      '}',

      '.utils-sortby--modal-item {',
      '  margin: 0 !important;',
      '  padding: 0 !important;',
      '}',

      /* Parent container — relative for absolute modal */
      '.productgrid--utils.utils-sortby {',
      '  position: relative;',
      '}'
    ].join('\n');

    var style = document.createElement('style');
    style.id = 'sortby-mobile-css';
    style.textContent = css;
    document.head.appendChild(style);
  }

  /* --- C: Preserve scroll position across filter / sort changes ------
         Empire uses two mechanisms depending on collection state:
           • AJAX update  — Empire replaces the product grid via fetch,
             then scrolls to the collection heading (scrollTo or
             scrollIntoView).
           • Full-page nav — filter links like /manufacturer_outdoor-fit
             trigger a normal page load, so the browser resets scroll.
         We handle both:
           1. Intercept window.scrollTo, window.scroll AND
              Element.prototype.scrollIntoView so that ANY programmatic
              scroll within 1.5 s of a filter/sort click is suppressed.
           2. Save scrollY to sessionStorage before navigation so we
              can restore it on the next page load.
     ----------------------------------------------------------------- */
  var SCROLL_KEY  = 'ows_collection_scrollY';
  var blockUntil  = 0;           /* timestamp — suppress scroll until */
  var savedY      = 0;           /* scrollY captured at click time    */

  /* -- Intercept all programmatic scroll methods ------------------ */
  var _nativeScrollTo    = window.scrollTo;
  var _nativeScroll      = window.scroll;
  var _nativeScrollInto  = Element.prototype.scrollIntoView;

  function isLocked() { return Date.now() < blockUntil && savedY > 0; }

  function guardedScroll() {
    if (isLocked()) return;
    return _nativeScrollTo.apply(window, arguments);
  }
  function guardedScrollIntoView() {
    if (isLocked()) return;
    return _nativeScrollInto.apply(this, arguments);
  }

  window.scrollTo = guardedScroll;
  window.scroll   = guardedScroll;
  Element.prototype.scrollIntoView = guardedScrollIntoView;

  /* Also intercept scrollTop property on <html> and <body> —
     Empire may set document.documentElement.scrollTop = 0 directly */
  var _scrollTopDesc = Object.getOwnPropertyDescriptor(
    Element.prototype, 'scrollTop'
  );
  if (_scrollTopDesc && _scrollTopDesc.set) {
    [document.documentElement, document.body].forEach(function (el) {
      if (!el) return;
      Object.defineProperty(el, 'scrollTop', {
        get: function () { return _scrollTopDesc.get.call(this); },
        set: function (v) {
          if (isLocked() && v < savedY) return;
          _scrollTopDesc.set.call(this, v);
        },
        configurable: true
      });
    });
  }

  /* -- Save scroll + start suppression window --------------------- */
  function armScrollLock() {
    savedY     = window.scrollY;
    blockUntil = Date.now() + 1500;
    try { sessionStorage.setItem(SCROLL_KEY, String(savedY)); } catch (e) {}
  }

  function attachScrollSavers() {
    /* Sidebar filter links (covers both desktop and mobile —
       on mobile the same sidebar slides out as an overlay) */
    var sidebar = document.querySelector('.productgrid--sidebar');
    if (sidebar) {
      sidebar.addEventListener('click', function (e) {
        if (e.target.closest('a')) armScrollLock();
      });
    }

    /* Desktop sort <select> */
    var select = document.getElementById('product_grid_sort');
    if (select) {
      select.addEventListener('change', armScrollLock);
    }

    /* Mobile sort modal buttons */
    var modal = document.querySelector('.utils-sortby--modal');
    if (modal) {
      modal.addEventListener('click', function (e) {
        if (e.target.closest('button')) armScrollLock();
      });
    }

    /* Catch-all: any click on a sort-trigger button anywhere */
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-productgrid-trigger-sort-button]');
      var link = e.target.closest('.filter-item a');
      if (btn || link) armScrollLock();
    }, true);  /* capture phase — fires before Empire's handler */

    /* FIX 2026-08-03: the old 'last-resort' beforeunload saver banked
       scrollY on EVERY departure from a collection page - clicking a
       product, the cart, a nav link or page 2 - so the next page pulled
       itself down to that offset. Filter/sort clicks already save via
       the armScrollLock path above, so this was pure collateral. */
  }

  /* -- Restore scroll after full-page navigation ------------------ */
  function restoreScroll() {
    /* FIX 2026-08-03: only ever restore on a collection page. Previously
       this ran on every template (product, cart, page 2, blog...) and
       yanked the page down to a stale saved offset. */
    if (!/\/collections\//.test(window.location.pathname)) {
      try { sessionStorage.removeItem(SCROLL_KEY); } catch (e) {}
      return;
    }
    try {
      var saved = sessionStorage.getItem(SCROLL_KEY);
      if (saved !== null) {
        sessionStorage.removeItem(SCROLL_KEY);
        var y = parseInt(saved, 10);
        if (!isNaN(y) && y > 0) {
          savedY     = y;
          blockUntil = Date.now() + 2000;

          /* Multiple restore attempts — mobile can be slow to render.
             The block window swallows Empire's scroll-to-top in between. */
          var attempts = [50, 150, 400, 800];
          attempts.forEach(function (ms) {
            setTimeout(function () {
              _nativeScrollTo.call(window, 0, y);
            }, ms);
          });
        }
      }
    } catch (e) {}
  }

  /* --- Bootstrap --------------------------------------------------- */
  function init() {
    pruneDesktopSelect();
    pruneMobileModal();
    injectMobileCSS();
    attachScrollSavers();
    restoreScroll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Re-run after Empire AJAX filter updates (sort controls may
     re-render inside the product grid area) */
  function observeGrid() {
    var grid = document.querySelector('[data-productgrid-main]') ||
               document.querySelector('.productgrid--outer');
    if (!grid) return;

    var observer = new MutationObserver(function () {
      pruneDesktopSelect();
      pruneMobileModal();
    });
    observer.observe(grid, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeGrid);
  } else {
    observeGrid();
  }
})();
